import {Dispatch, FC, SetStateAction, useState} from "react";
import {ModalFooter} from "../../../../lib/src/components/layout/ModalProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSquare} from "@fortawesome/free-regular-svg-icons";
import {faSquareCheck} from "@fortawesome/free-solid-svg-icons";

export const SavePageModal: FC<{ onFinished: (shouldNotify?: boolean) => void, setEditable: Dispatch<SetStateAction<boolean>> }> = ({ onFinished, setEditable }) => {
  const [shouldNotify, setShouldNotify] = useState<boolean>(false)
  const save = async () => {
    onFinished(shouldNotify)
    setEditable(false)
  }

  return <>
    <div className={'flex flex-col space-y-4'}>
      <div>Weet u zeker dat u deze wijzigingen op wilt slaan?</div>

      <div className={'flex flex-row space-x-4 items-center px-2 py-1 hover:bg-brand-100 hover:cursor-default rounded-md'} onClick={() => setShouldNotify(!shouldNotify)}>
        <FontAwesomeIcon className={'text-brand-primary'} icon={shouldNotify ? faSquareCheck : faSquare} />
        <div>Andere leden op de hoogte stellen van deze update?</div>
      </div>
    </div>
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </>
}